import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Ccpa User Opt Out Denied Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M.77 17.26a6.75 6.75 0 0 1 6.75-6.75 6.9 6.9 0 0 1 2.65.54M3.39 4.89a4.13 4.13 0 1 0 8.26 0 4.13 4.13 0 1 0-8.26 0M10.79 23.25a4.54 4.54 0 0 1 0-9.07h7.94a4.54 4.54 0 0 1 0 9.07ZM13.23 17.25l3 3M16.23 17.25l-3 3" })
    ], -1)
  ]))]))
}
export default { render: render }